import * as z from 'zod';

const graphqlErrorSchema = z.object({
  response: z.object({
    errors: z.array(z.object({ message: z.string() })).nonempty(),
  }),
});

export const getErrorMessage = (error: unknown, defaultMessage = 'An unknown error occurred') => {
  if (!error) {
    return defaultMessage;
  }

  const gqlError = graphqlErrorSchema.safeParse(error);
  const firstGqlError = gqlError.success ? gqlError.data.response.errors[0] : null;

  if (firstGqlError) {
    return firstGqlError.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return defaultMessage;
};
